import { Divider, Menu, MenuProps } from "antd";
import { AppstoreOutlined, GroupOutlined, HomeOutlined, MailOutlined, NotificationOutlined, SearchOutlined, UngroupOutlined, UnorderedListOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";


import './PrivateMenuComponent.scss'
import { GetFormattedUrl } from "../../../utils/urls";
import { useAppConfig } from "../../../Contexts/AppConfigContext";
import { CurrencySelector, LanguageSelector } from "..";
import { useEffect, useState } from "react";
import { use } from "echarts";
import { useSessionData } from "../../../Contexts/SessionDataContext";
import { useTranslation } from "react-i18next";

interface PrivateMenuComponentProps {
  onSelectItem: (key: string) => void;
  loadingLogout?: boolean;
}

const PrivateMenuComponent = (props: PrivateMenuComponentProps): JSX.Element => {
  const navigate = useNavigate();
  const appConfig = useAppConfig();
  const userSessionData = useSessionData();
  const { t } = useTranslation();
  type MenuItem = Required<MenuProps>['items'][number];

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }
  
  const showUsersMenu = (userSessionData.userData.role == 'super_admin' || userSessionData.userData.role == 'wa_admin')
    && (userSessionData.userData.typeAccount == 'agency_agent' || userSessionData.userData.typeAccount == 'corporate_agent');

  const expandedIcons: MenuItem[] = [
    getItem('', 'currency-selector', <LanguageSelector />),
    getItem('', 'currency-selector', <CurrencySelector />),
    { type: 'divider' }
  ];

  const itemsForTabletAndDesktop: MenuItem[] = [
    getItem(t("dashboard.home"), 'dashboard', <HomeOutlined className='app-icon' />),
    getItem(t("dashboard.book"), 'booking-engine', <SearchOutlined className='app-icon' />),
    ...(showUsersMenu ? [getItem(t("dashboard.users"), 'users', <UserOutlined className='app-icon' />)] : []),

    getItem(t("dashboard.see-bookings"), 'booking-page', <UnorderedListOutlined className='app-icon' />),

    getItem(t("dashboard.news"), 'news-page', <NotificationOutlined className='app-icon' />),

    getItem(t("dashboard.contact"), 'sub2', <MailOutlined className='app-icon' />, [
      getItem(t("dashboard.contact-form"), 'contact-page', <UngroupOutlined className='app-icon' />),
      getItem(t("dashboard.group-form"), 'groups-and-conventions', <GroupOutlined className='app-icon' />),
    ]),

    /* getItem('Páginas error', 'sub3', <AppstoreOutlined className='app-icon'/>, [
       getItem('403', '403'),
       getItem('404', '404'),
       getItem('500', '500'),
       getItem('Loading...', 'loading-page')
       ]),*/
  ];

  const itemsForMobile: MenuItem[] = [
    ...expandedIcons,
    ...itemsForTabletAndDesktop
  ];

  const goPage = (page: string): void => {
    navigate(`${GetFormattedUrl(`private/${page}`)}`);
  }


  const [selectedKey, setSelectedKey] = useState<string>('dashboard');

  //Get the last part of the url to set the selected menu item


  useEffect(() => {
    const path = window.location.pathname;

    if (path.includes('news-page')) {
      setSelectedKey('news-page');
    } else {
      const lastPart = path.split('/').pop();
      if (lastPart) {
        setSelectedKey(lastPart);
      }
    }
  }, [window.location.pathname]);


  return (<div className="private-menu">
    <Menu
      className="menu"
      defaultSelectedKeys={['dashboard']}
      selectedKeys={[selectedKey]}
      defaultOpenKeys={['sub1']}
      mode={appConfig.device === "mobile" ? "inline" : "vertical"}
      items={appConfig.device === "mobile" ? itemsForMobile : itemsForTabletAndDesktop}
      onClick={(e) => {
        if (props.loadingLogout) return; // bloquear
        if (e.key !== 'currency-selector' && e.key !== 'language-selector') {
          goPage(e.key)
          props.onSelectItem(e.key);
        }
      }}
    />

    <div className="menu-extra-box">
      <p className="menu-extra-title">
        {t(`account-type.${userSessionData?.userData?.typeAccount ?? ""}`)}

      </p>
      <p className="menu-extra-value">
        {userSessionData.userData.nameOrganization}
      </p>

      <p className="menu-extra-title">
        {t('dashboard.address')}
      </p>
      <p className="menu-extra-value">
        {userSessionData.userData.addressOrganization}
      </p>
    </div>

  </div>)
}

export default PrivateMenuComponent;

